import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRankRocketGold = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1786 2.04984C14.861 0.827552 17.139 0.827554 18.8214 2.04984L28.3955 9.00588C30.0779 10.2282 30.7818 12.3947 30.1392 14.3724L26.4822 25.6276C25.8396 27.6053 23.9966 28.9443 21.9172 28.9443H10.0828C8.00335 28.9443 6.16037 27.6053 5.51777 25.6276L1.86076 14.3724C1.21817 12.3947 1.92213 10.2282 3.60447 9.00588L13.1786 2.04984Z",
			fill: "#FBD551"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6337 18.2783C14.15 17.8948 13.7118 17.4565 13.3282 16.9728C13.3383 16.9171 13.349 16.8616 13.3602 16.8062C13.5929 15.66 14.0707 14.6027 14.7365 13.6915C16.1915 11.7 18.5446 10.4064 21.1998 10.4062C21.1998 13.0616 19.9061 15.4148 17.9147 16.87C17.0035 17.5359 15.9461 18.0137 14.7998 18.2464C14.7447 18.2576 14.6893 18.2682 14.6337 18.2783Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9998 13.6062C12.2325 13.6062 10.7998 15.0389 10.7998 16.8062H13.3602C13.5929 15.66 14.0707 14.6027 14.7365 13.6915C14.5 13.6357 14.2533 13.6062 13.9998 13.6062Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.7998 20.8062C16.5671 20.8062 17.9998 19.3736 17.9998 17.6062C17.9998 17.3529 17.9704 17.1064 17.9147 16.87C17.0035 17.5359 15.9461 18.0137 14.7998 18.2464V20.8062Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.9147 16.87C17.9704 17.1064 17.9998 17.3529 17.9998 17.6062C17.9998 19.3736 16.5671 20.8062 14.7998 20.8062V18.2464M17.9147 16.87C19.9061 15.4148 21.1998 13.0616 21.1998 10.4062C18.5446 10.4064 16.1915 11.7 14.7365 13.6915M17.9147 16.87C17.0035 17.5359 15.9461 18.0137 14.7998 18.2464M14.7365 13.6915C14.5 13.6357 14.2533 13.6062 13.9998 13.6062C12.2325 13.6062 10.7998 15.0389 10.7998 16.8062H13.3602M14.7365 13.6915C14.0707 14.6027 13.5929 15.66 13.3602 16.8062M14.7998 18.2464C14.7447 18.2576 14.6893 18.2682 14.6337 18.2783C14.15 17.8948 13.7118 17.4565 13.3282 16.9728C13.3383 16.9171 13.349 16.8616 13.3602 16.8062M12.1662 18.0813C11.5796 18.5189 11.1998 19.2182 11.1998 20.0062C11.1998 20.1326 11.2096 20.2566 11.2284 20.3777C11.3494 20.3965 11.4735 20.4062 11.5998 20.4062C12.3878 20.4062 13.0872 20.0264 13.5247 19.4399",
			stroke: "white",
			strokeWidth: .8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4003 14.0031C18.4003 14.445 18.0421 14.8031 17.6003 14.8031C17.1585 14.8031 16.8003 14.445 16.8003 14.0031C16.8003 13.5613 17.1585 13.2031 17.6003 13.2031C18.0421 13.2031 18.4003 13.5613 18.4003 14.0031Z",
			fill: "white",
			stroke: "white",
			strokeWidth: .8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgRankRocketGold;
